import {
  CATALOG_BOOKSHELF_DETAIL_SET_DATA,
  CATALOG_BOOKSHELF_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  userId: null,
  bookshelfId: null,
  bookshelf: null,
  books: null,
  paginateBy: 24,
  pageNumber: 1,
  lastPageNumber: 0,
  subscriptionId: null,
  bookType: null,
};

export default function bookshelfDetail(state = initialState, action) {
  switch (action.type) {
    case CATALOG_BOOKSHELF_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_BOOKSHELF_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
